<template>
  <v-col>
    <v-row class="mb-8">
      <v-btn color="primary" @click="CHANGE_USATO_CLIENTI_COMPONENT('Index')">Indietro</v-btn>
    </v-row>
    <br>
    <v-row>
      <v-card min-width="100%">
        <v-form ref="form" v-model="valid" :lazy-validation="true" autocomplete="off">

          <v-card-text>
            <v-col>
              <v-row>
                <v-col>
                  <h1 class="primary--text">Nuova dichiarazione di vendita</h1>
                </v-col>
              </v-row>
              <v-row>
                <v-col>
                  <v-autocomplete label="Cerca cliente" v-model="customerModel" :search-input.sync="customerSearch"
                    :items="customers" :loading="isLoading" hide-no-data hide-selected item-text="text" item-value="id"
                    return-object></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4" lg="6">
                  <v-text-field label="Nome" v-model="customer.name" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4" lg="6">
                  <v-text-field label="Cognome" v-model="customer.surename" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field label="Codice fiscale" v-model="customer.fiscal_code" :rules="[rules.required, rules.validFiscalCode]"
                    required>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field label="Email" v-model="customer.email" :rules="[rules.required, rules.validEmail]" required>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field label="Telefono" v-model="customer.phone" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>
              </v-row>
              <br />
              <br />
              <h2 class="secondary--text">Documento di identità</h2>
              <br />
              <v-divider />
              <br />

              <v-row>
                <v-col cols="12" md="6" lg="4">
                  <v-select label="Tipo" v-model="IDDocs.type" :items="types" :rules="[rules.required]"></v-select>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field label="Numero" v-model="IDDocs.number" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-menu v-model="menu3" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="IDDocs.expiration" label="Scadenza" readonly v-bind="attrs" v-on="on"
                        :rules="[rules.required]" required>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="IDDocs.expiration" @input="menu3 = false" locale="it-IT">
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-text-field label="Luogo di nascita" v-model="IDDocs.birthplace" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="4">
                  <v-menu v-model="menu2" :close-on-content-click="false" :nudge-right="40"
                    transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="IDDocs.birthday" label="Data di nascita" readonly v-bind="attrs" v-on="on"
                        :rules="[rules.required]" required>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="IDDocs.birthday" @input="menu2 = false" locale="it-IT">
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <br />
              <br />
              <h2 class="secondary--text">Indirizzo</h2>
              <br />
              <v-divider />
              <br />
              <v-row>
                <v-col>
                  <v-autocomplete label="Cerca comune" v-model="model" :search-input.sync="search" :items="geoSearch"
                    :loading="isLoading" hide-no-data return-object></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" lg="3">                  
                  <v-text-field label="Comune" v-model="address.municipality"
                    :rules="[rules.required]" required>
                  </v-text-field>                  
                </v-col>
                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="CAP" v-model="address.cap" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="Provincia" v-model="address.province" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="Indirizzo" v-model="address.address" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>
              </v-row>

              <br />
              <br />
              <h2 class="secondary--text">Dispositivo</h2>
              <br />
              <v-divider />
              <br />

              <v-row>
                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="IMEI" v-model="secondHand.serial_number" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="EAN" v-model="secondHand.ean">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="Marchio" v-model="secondHand.brand" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="Modello" v-model="secondHand.model" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="Colore" v-model="secondHand.color" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="Costo" v-model="secondHand.cost" type="number" :rules="[rules.required]"
                    required>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="Prezzo" v-model="secondHand.price" type="number" :rules="[rules.required]"
                    required>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="Grado Estetico" v-model="secondHand.grade" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="RAM" v-model="secondHand.ram" :rules="[rules.required]">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" lg="3">
                  <v-text-field label="HDD" v-model="secondHand.disk_space" :rules="[rules.required]" required>
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="6">
                  <v-textarea label="Descrizione" v-model="secondHand.description" :rules="[rules.required]">
                  </v-textarea>
                </v-col>
              </v-row>
            </v-col>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-col>
              <v-row>
                <v-col>
                  <v-btn :disabled="!valid" color="success" class="mr-4" @click="submit">
                    Salva Dich. di vendita
                  </v-btn>

                  <v-btn color="error" class="mr-4" @click="reset">
                    Reset Modulo
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-row>
    <snack-notification :snack="snack" />
  </v-col>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'
import { getDVPPath } from '../../../utils'
import { accounting } from './../../../mixins/accounting'

import SnackNotification from './../../SnackNotification'

export default {
  name: 'Insert',
  components: {
    SnackNotification
  },
  mixins: [accounting],
  data() {
    return {
      secondHand: {
        progressive: 1,
        customer_id: null,
        serial_number: null,
        ean: null,
        brand: null,
        model: null,
        color: null,
        cost: null,
        price: null,
        grade: null,
        ram: null,
        disk_space: null,
        description: null,
      },
      menu2: false,
      menu3: false,
      types: [
        'Carta d\'identità',
        'Patente',
        'Passaporto'
      ],
      model: null,
      search: null,
      customerSearch: null,

      customerModel: null,
      customers: [],
      usati: [],
      customer: {
        name: null,
        surename: null,
        phone: null,
        email: null,
        fiscal_code: null,
        note: null,
      },
      IDDocs: {
        type: null,
        number: null,
        municipality: null,
        province: null,
        birthday: null,
        expiration: null
      },
      address: {
        address: null,
        city: null,
        municipality: null,
        province: null,
        code: null,
        region: null,
        cap: null,
      },

      search: '',
      geoData: require('../../../config/geo_data.json'),
      valid: false,
      isLoading: false,
      snack: {
        error: null,
        visible: null,
        message: null
      },
      rules: {
        required: value => !!value || 'Campo obbligatorio.',
        required: (value) => !!value || 'Campo obbligatorio.',
        validEmail: (value) => {
          if (value) {
            return (
              /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                value
              ) || 'Formato email non valido.'
            )
          } else {
            return true
          }
        },
        validFiscalCode: (value) => {
          if (value) {
            return (
              /^(?:[A-Z][AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/i.test(
                value
              ) || 'Formato codice fiscale non valido.'
            )
          } else {
            return true
          }
        },
      },
      config: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
      },
    }
  },
  methods: {
    ...mapMutations([
      'CHANGE_USATO_CLIENTI_COMPONENT'
    ]),

    async fetchCustomers() {
      const { data } = await axios.get(`${process.env.VUE_APP_API}/v2/customers/fetch`, this.config)

      this.customers = data.map(el => {
        el.text = `${el.name} ${el.surename}`
        return el
      })
    },

    async fetchUsati() {
      try {
        const {
          data
        } = await axios.get(`${process.env.VUE_APP_API}/secondHand/customer/fetch`, this.config)

        this.usati = data

      } catch (error) {

        console.log(error)

        this.usati = []
      }
    },

    geoExtract(city) {
      let res = {}

      this.geoData.regioni.map((regione) => {
        regione.province.map((provincia) => {
          provincia.comuni.map((comune) => {
            if (comune.nome.toLowerCase() == city.toLowerCase()) {
              res = {
                regione: regione.nome,
                provincia: provincia.nome,
                codice: provincia.code,
                comune: comune.nome,
                cap: comune.cap,
              }
            }
          })
        })
      })

      return res
    },

    async submit() {

      if (this.$refs.form.validate()) {

        const currentYear = new Date().getFullYear()
        const months = ["GEN", "FEB", "MAR", "APR", "MAG", "GIU", "LUG", "AGO", "SET", "OTT", "NOV", "DIC"];
        const currentMonth = months[new Date().getMonth()];

        this.snack = Object.assign({}, {
          error: null,
          visible: null,
          message: null
        })

        /* Gestione per creazione nuovo utente durante la creazione della DVP - INIZIO */
        if (this.secondHand.customer_id === null) {
          const { data } = await axios.post(`${process.env.VUE_APP_API}/customers/create`,
            { address: this.address, IDDocs: this.IDDocs, customer: this.customer }, this.config
          )
          if (data.status) {
            this.secondHand.customer_id = data.customerId
          }
        }
        /* FINE */

        /*Gestione numero progressivo DVP - INIZIO */
        if (this.usati.lenght !== 0) {
          const { data } = await axios.get(`${process.env.VUE_APP_API}/secondHand/customer/fetch-last-progressive`, this.config)
          const lastProgressive = data[0].LastProgressive
          const yearProgressive = data[0].YearProgressive

          if (yearProgressive !== currentYear) {
            await axios.get(`${process.env.VUE_APP_API}/secondHand/customer/reset-progressive`, this.config)
            lastProgressive = 0
          }
          this.secondHand.progressive = lastProgressive + 1
        }
        /* FINE */

        const { data } = await axios.post(`${process.env.VUE_APP_API}/v2/secondHand/customer/create`, this.secondHand, this.config)

        if (data.status) {

          /* Creazione PDF DVP - INIZIO */
          this.secondHand.pdf_path = getDVPPath(this.customer.name, this.customer.surename, this.secondHand.serial_number, this.secondHand.brand, this.secondHand.model, this.secondHand.progressive)
          
          let dvpInfo = { secondHand: this.secondHand, customer: this.customer, address: this.address, IDDocs: this.IDDocs }
          await this.pdfCreate(dvpInfo);
          /* FINE */

          this.snack = Object.assign({}, {
            visible: true,
            error: false,
            message: 'Dich. di vendita salvata correttamente!'
          })

          this.reset()
        } else {

          this.snack = Object.assign({}, {
            visible: true,
            error: true,
            message: 'Errore nel salvataggio.'
          })
        }

      }
    },

    async pdfCreate(payload) {

      try {
        let {
          data
        } = await axios.post(`${process.env.VUE_APP_API}/pdfCreate`, { payload: payload }, this.config)

        if (data) {
          console.log(data);
        } else {
          alert('Si è verificato un errore.')
        }

      } catch (error) {
        console.log(error)
      }
    },

    reset() {
      this.$refs.form.reset()
      this.secondHand = {
        progressive: null,
        customer_id: null,
        serial_number: null,
        ean: null,
        brand: null,
        model: null,
        color: null,
        cost: null,
        price: null,
        grade: null,
        ram: null,
        disk_space: null,
        description: null,
      }
      this.customerModel = null
    },
  },

  computed: {

    geoSearch() {
      if (!this.search) return

      let res = []

      this.geoData.regioni.map((regione) => {
        regione.province.map((provincia) => {
          provincia.comuni.map((comune) => {
            if (comune.nome.toLowerCase().includes(this.search.toLowerCase())) {
              res.push(comune.nome)
            }
          })
        })
      })

      return res
    },

    vat() {
      const price = parseFloat(this.secondHand.price || 0)

      if (price <= 0) return

      const res = this._calculateVat(0.00, price, false).toFixed(2)

      return res > 0 ? res : "0"
    },

    gain() {
      const price = parseFloat(this.secondHand.price || 0).toFixed(2)
      const cost = parseFloat(0).toFixed(2)
      const vat = parseFloat(this.vat || 0).toFixed(2)

      if (!this.vat || !price) return

      return parseFloat(price - vat - cost).toFixed(2)
    }
  },

  watch: {
    customerModel(val) {
      if (val) {

        val.ID_docs ? null : val.ID_docs = {
          type: null,
          number: null,
          birthplace: null,
          birthday: "",
          expiration: ""
        }

        val.ID_docs.birthday ? val.ID_docs.birthday = val.ID_docs.birthday.slice(0, 10) : null
        val.ID_docs.expiration ? val.ID_docs.expiration = val.ID_docs.expiration.slice(0, 10) : null

        val.addresses.length === 0 ? val.addresses[0] = {
          id: null,
          address: null,
          city: null,
          municipality: null,
          cap: null,
          province: null,
          code: null,
          region: null
        } : null

        this.customer = {
          name: val.name,
          surename: val.surename,
          phone: val.phone,
          email: val.email,
          fiscal_code: val.fiscal_code,
          note: val.note
        }

        this.IDDocs = { ...val.ID_docs }

        this.address = { ...val.addresses[0] }


        this.secondHand.customer_id = val.id

      } else {
        this.secondHand.customer_id = null
      }
    },

    model(city) {

      const res = this.geoExtract(city)

      this.address.region = res.regione
      this.address.province = res.provincia
      this.address.code = res.codice
      this.address.municipality = res.comune
      this.address.cap = res.cap
    },
  },



  async mounted() {
    await this.fetchCustomers()
    await this.fetchUsati()
  }
}
</script>